import React, { useState } from 'react';
import AddProject from '../AddProject';

function EditProject({ data }) {
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleEditComplete = () => {
        setIsEditing(false);
    };

    return (
        <>
            {isEditing ? (
                <AddProject
                    isEditMode={true}
                    editData={data}
                    onEditComplete={handleEditComplete}
                /> 
                // this is the component that will be used to edit the project but originally it was to add a project
            ) : (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    onClick={handleEditClick}
                    style={{ cursor: 'pointer' }}
                >
                    <path
                        d="M14.56 9L15.5 9.94L6.42 19H5.5V18.08L14.56 9ZM18.16 3C17.91 3 17.65 3.1 17.46 3.29L15.63 5.12L19.38 8.87L21.21 7.04C21.6 6.65 21.6 6 21.21 5.63L18.87 3.29C18.67 3.09 18.42 3 18.16 3ZM14.56 6.19L3.5 17.25V21H7.25L18.31 9.94L14.56 6.19Z"
                        fill="#02171D"
                    />
                </svg>
            )}
        </>
    );
}

export default EditProject;